/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const dropDown = () => {
		if(document.querySelector('.js-news-yearList')) {
			// 日付文字列（YYYY.MM.DD形式）から年度を計算する関数
			const dateToFiscalYear = (dateStr) => {
				const parts = dateStr.split('.');
				const year = parseInt(parts[0], 10);
				const month = parseInt(parts[1], 10);
				// 4月1日以降なら年をそのまま、3月31日以前なら年-1
				return month >= 4 ? year : year - 1;
			};

			// 最新と最古の日付を取得して年度に変換
			const latestDateStr = document.querySelector('.js-news-latest-year').textContent;
			const earliestDateStr = document.querySelector('.js-news-earliest-year').textContent;
			const latest = dateToFiscalYear(latestDateStr);
			const earliest = dateToFiscalYear(earliestDateStr);

			// ドロップダウンリスト要素を取得
			const yearList = document.querySelector('.js-news-yearList');
			// 現在のパスから年度の部分を除いたベースパスを取得
			const currentPath = location.pathname.replace('index.html','');
			const basePath = currentPath.replace(/\d{4}\/?$/, ''); // 末尾の年度を削除
			const optionVal = (_num) => {
				// ベースパスに年度を追加してパスを生成
				return basePath + _num + `/`;
			};
			// HTML側の既存の「最新」オプションに値を設定
			const existingOptions = yearList.querySelectorAll('option');
			existingOptions.forEach(option => {
				if (option.textContent.trim() === '最新' && option.value === '') {
					option.value = basePath; // インデックスページのパス
					// インデックスページの場合はselectedを設定
					if (!currentPath.match(/\d{4}/)) {
						option.selected = true;
					}
				}
			});
			// 最新から最古の年度までのオプションを生成し追加
			for(var i = latest; i >= earliest; i--) {
				const option = document.createElement('option');
				option.textContent = i.toString() + '年度';
				option.value = optionVal(i);
				// 現在のパスに年度が含まれている場合、一致する年度をselected
				if (currentPath.match(/\d{4}/) && currentPath.includes(i.toString())) {
					option.selected = true;
				}
				yearList.appendChild(option);
			}
			// ドロップダウンリストの変更イベントを処理(ボタンの場合)
			// const yearListSubmit = document.querySelector('.js-news-yearList-submit');
			// yearListSubmit.addEventListener('click', function () {
			// 	location.href = yearList.value;
			// });

			// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
			document.querySelector('.js-news-yearList').addEventListener('change', function() {
				location.href = yearList.value;
			});
		}
	};

	const newsAnchor = () => {
		const anchorLinks = document.querySelectorAll('.js-news-anchor');
		if (anchorLinks.length) {
			// ページ遷移後のスクロール処理（ブラウザのネイティブアンカースクロールとの競合を回避）
			const targetId = sessionStorage.getItem('js-news-anchor-scroll');
			if (targetId) {
				sessionStorage.removeItem('js-news-anchor-scroll');
				const target = document.getElementById(targetId);
				if (target) {
					const doScroll = () => {
						const offset = FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp
							? FUNCTIONS.va.header.sp
							: FUNCTIONS.va.header.desktop;
						const top = target.getBoundingClientRect().top + window.scrollY - offset;
						window.scrollTo({ top, behavior: 'smooth' });
					};
					'complete' === document.readyState ? doScroll() : window.addEventListener('load', doScroll);
				}
			}

			anchorLinks.forEach(link => {
				link.addEventListener('click', function(e) {
					e.preventDefault();
					const href = link.getAttribute('href');
					if (href) {
						// ハッシュをURLに含めずsessionStorageでスクロール先を伝達
						sessionStorage.setItem('js-news-anchor-scroll', 'js-news-top');
						location.href = href.split('#')[0];
					}
				});
			});
		}
	}

	// ニュースリストを描画（※ニュース描画が不要な案件では削除）
	// const createNews = async () => {
	// 	// htmlをテンプレートとして使用
	// 	let html = await fetch('/cnt_common/js/html/news-list.html').then(res => res.text());

	// 	fetch(cmsNewsJson())
	// 	.then(response => response.json())
	// 	.then((data) => {
	// 		const newsData = data.rt_bn_news;
	// 		if(newsData.length) {
	// 			for(let i=0; i<newsData.length; i++) {
	// 				let _title = newsData[i].rt_cf_n_title.content[0];
	// 				let _category = newsData[i].rt_cf_n_category_name.content[0];
	// 				let _date = newsData[i].rt_cf_n_date.content;
	// 				let _href = newsData[i].rt_cf_n_href;
	// 				let _hrefLink = _href.href;
	// 				let _target = _href.target;
	// 				let _pdf = newsData[i].rt_cf_n_attachment_file_icon_pdf;
	// 				let _pdfSize = newsData[i].rt_cf_n_attachment_file_size;
	// 				let icon = _pdf !== null ? pdfIcon : (_target === '_blank' ? blankIcon : '');
	// 				let pdfSpan = '';
	// 				if(_pdfSize !== null) {
	// 					pdfSpan = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize.content)}</span>)</span>`;
	// 				}

	// 				// UTCのまま出力されている場合はUTC→JSTに変換
	// 				// new Date(_date)

	// 				let isDisable = _hrefLink === '#' ? 'is-disable' : '';

	// 				let thisHtml = html
	// 					.replaceAll('{!href!}', _hrefLink)
	// 					.replaceAll('{!target!}', _target)
	// 					.replaceAll('{!isDisable!}', isDisable)
	// 					.replaceAll('{!date!}', _date)
	// 					.replaceAll('{!category!}', _category)
	// 					.replaceAll('{!title!}', _title)
	// 					.replaceAll('{!pdfSize!}', pdfSpan)
	// 					.replaceAll('{!icon!}', icon)
	// 			}
	// 		}
	// 	});
	// }

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		dropDown();
		newsAnchor();
		// createNews(); // ニュース描画が不要な案件では削除
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
